module.exports = __webpack_public_path__ + "static/media/board.dc9d354b.png";